import "./reviewItem.scss";

import React, { useState } from "react";
import FsLightbox from "fslightbox-react";
import dayjs from "dayjs";

import { Rating } from "@sbi-international/boutik.gatsby.plugin.components";
import { ProductReviewsReview } from "../../../models/productReviewsModel";
import useMobileDetect from "../../../hooks/useMobileDetect";

// TODO: Fix this

type ReviewItemProps = {
    review: ProductReviewsReview;
    hidden: boolean;
};

export default function ReviewItem(props: ReviewItemProps) {
    const { review, hidden } = props;
    const isMobile = useMobileDetect().isMobile();
    const [isLightBoxVisible, setIsLightBoxVisible] = useState(false);

    return (
        <div className="review-item" hidden={hidden}>
            <div className="reviewer">{review.nickname}</div>
            <p className="review-date">{dayjs(review.created_at).format("YYYY-MM-DD")}</p>
            <div className="review-head">
                <Rating.RatingScore ratingScore={review?.rating as number} />
                <strong>{review.summary == '--' ? '' : review.summary}</strong>
            </div>

            <div className="review-container">{review.text}</div>
            {review.imageUrl != '' && (
                <>
                    <div className={`review-image ${isMobile ? "mobile" : "desktop"}`}>
                        <img
                            className="review-img"
                            src={review.imageUrl}
                            onClick={() => setIsLightBoxVisible(!isLightBoxVisible)}
                            alt=""
                        />
                    </div>
                    <FsLightbox
                        toggler={isLightBoxVisible}
                        sources={[review.imageUrl]}
                        exitFullscreenOnClose={true}
                    />
                </>
            )}
        </div>
    );
}
